var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 3",
    clipPath: "url(#clip0_1_13252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 12.5261C10.5005 12.7853 10.3981 13.0341 10.2153 13.2179C10.0325 13.4016 9.78421 13.5053 9.525 13.5061H1.725C1.59662 13.5058 1.46954 13.4803 1.35104 13.4309C1.23254 13.3815 1.12494 13.3092 1.03439 13.2182C0.943842 13.1272 0.872118 13.0192 0.823321 12.9004C0.774524 12.7817 0.74961 12.6545 0.750005 12.5261V1.7361C0.749742 1.60767 0.774778 1.48044 0.823685 1.36169C0.872591 1.24293 0.944409 1.13497 1.03504 1.04397C1.12567 0.952965 1.23334 0.880706 1.35189 0.831314C1.47045 0.781922 1.59757 0.756366 1.726 0.756104L9.526 0.769104C9.78504 0.770162 10.0331 0.873943 10.2157 1.05767C10.3983 1.2414 10.5005 1.49007 10.5 1.7491V12.5261Z",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.246 6.54389C23.2442 6.80071 23.1404 7.04629 22.9576 7.22667C22.7748 7.40706 22.5278 7.50748 22.271 7.50589H14.471C14.3438 7.50681 14.2177 7.48265 14.0998 7.43479C13.9819 7.38693 13.8747 7.31631 13.7841 7.22697C13.6936 7.13762 13.6215 7.03131 13.5721 6.9141C13.5226 6.79689 13.4968 6.67109 13.496 6.54389V1.73088C13.4976 1.47433 13.601 1.22889 13.7834 1.04851C13.9659 0.86813 14.2124 0.767555 14.469 0.768885L22.269 0.755885C22.5261 0.754021 22.7734 0.854297 22.9566 1.03468C23.1398 1.21506 23.2439 1.4608 23.246 1.71788V6.54389Z",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5 22.2909C10.4992 22.4184 10.4733 22.5445 10.4238 22.662C10.3743 22.7795 10.3021 22.8861 10.2114 22.9757C10.1206 23.0653 10.0132 23.1362 9.89505 23.1843C9.77694 23.2323 9.65051 23.2567 9.523 23.2559L1.723 23.2429C1.46618 23.2439 1.21944 23.143 1.03699 22.9622C0.854547 22.7815 0.751323 22.5357 0.75 22.2789V17.4699C0.750655 17.3425 0.776401 17.2166 0.825766 17.0992C0.875131 16.9818 0.947148 16.8753 1.0377 16.7858C1.12825 16.6963 1.23556 16.6255 1.35349 16.5774C1.47142 16.5294 1.59766 16.5051 1.725 16.5059H9.525C9.78209 16.5045 10.0292 16.6053 10.212 16.7861C10.3948 16.9668 10.4984 17.2128 10.5 17.4699V22.2909Z",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.472 23.2561C14.3435 23.2558 14.2163 23.2303 14.0977 23.1808C13.979 23.1313 13.8713 23.059 13.7807 22.9679C13.69 22.8768 13.6182 22.7687 13.5694 22.6498C13.5206 22.531 13.4956 22.4036 13.496 22.2751V11.4871C13.4956 11.3587 13.5205 11.2314 13.5693 11.1126C13.6181 10.9938 13.6898 10.8858 13.7803 10.7947C13.8709 10.7036 13.9785 10.6312 14.097 10.5817C14.2155 10.5322 14.3426 10.5065 14.471 10.5061H22.271C22.3994 10.5065 22.5265 10.5322 22.645 10.5817C22.7635 10.6312 22.8711 10.7036 22.9617 10.7947C23.0522 10.8858 23.1239 10.9938 23.1727 11.1126C23.2215 11.2314 23.2464 11.3587 23.246 11.4871V22.2621C23.2465 22.5212 23.1443 22.77 22.9617 22.9539C22.7792 23.1378 22.5311 23.2418 22.272 23.2431L14.472 23.2561Z",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_13252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3dd311575d5c1b59583cc38b49fe357d.svg";
export { ForwardRef as ReactComponent };